import { render, staticRenderFns } from "./Textbox1.vue?vue&type=template&id=85a2c7a4&scoped=true&"
import script from "./Textbox1.vue?vue&type=script&lang=js&"
export * from "./Textbox1.vue?vue&type=script&lang=js&"
import style0 from "./Textbox1.vue?vue&type=style&index=0&id=85a2c7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a2c7a4",
  null
  
)

export default component.exports